import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

const customPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: 'var(--primary-50)',
      100: 'var(--primary-100)',
      200: 'var(--primary-200)',
      300: 'var(--primary-300)',
      400: 'var(--primary-400)',
      500: 'var(--primary-500)',
      600: 'var(--primary-600)',
      700: 'var(--primary-700)',
      800: 'var(--primary-800)',
      900: 'var(--primary-900)',
      950: 'var(--primary-950)',
      //  contrastColor: 'var(--primary-contrast)',
    },
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: 'var(--basic-50)',
          100: 'var(--basic-100)',
          200: 'var(--basic-200)',
          300: 'var(--basic-300)',
          400: 'var(--basic-400)',
          500: 'var(--basic-500)',
          600: 'var(--basic-600)',
          700: 'var(--basic-700)',
          800: 'var(--basic-800)',
          900: 'var(--basic-900)',
          950: 'var(--basic-950)',
          //contrastColor: 'var(--text-control-basic-color)',
        },
      },
      dark: {
        surface: {
          0: '#ffffff',
          50: 'var(--basic-0)',
          100: 'var(--basic-100)',
          200: 'var(--basic-200)',
          300: 'var(--basic-300)',
          400: 'var(--basic-400)',
          500: 'var(--basic-500)',
          600: 'var(--basic-600)',
          700: 'var(--basic-700)',
          800: 'var(--basic-800)',
          900: 'var(--basic-900)',
          950: 'var(--basic-950)',
          //      contrastColor: 'var(--basic-contrast)',
        },
      },
    },
  },
  components: {
    inputgroup: {
      colorScheme: {
        light: {
          addon: {
            background: '{surface.0}',
          },
        },
        dark: {
          addon: {
            background: '{surface.950}',
          },
        },
      },
    },
    checkbox: {
      root: {
        borderRadius: '100%',
      },
    },
    radiobutton: {
      icon: {
        checkedColor: '{primary.500}',
      },
    },
    tabs: {
      activeBar: {
        height: '2px',
        background: '{primary.500}',
      },
      tablist: {
        borderColor: '{surface.200}',
        borderWidth: '2px',
      },
      tab: {
        activeBorderColor: 'transparent',
        color: '{surface.600}',
        hoverColor: '{layout-text-color}',
        activeColor: '{layout-text-color}',
        fontWeight: '400',
      },
      colorScheme: {
        light: {
          tablist: {
            borderColor: '{surface.200}',
          },
          tab: {
            background: '{surface.0}',
            hoverBackground: 'transparent',
            activeBackground: '{surface.0}',
          },
        },
        dark: {
          tablist: {
            borderColor: '{surface.700}',
            borderWidth: '2px',
          },
          tab: {
            background: '{surface.900}',
            hoverBackground: 'transparent',
            activeBackground: '{surface.900}',
          },
        },
      },
    },
    chip: {
      colorScheme: {
        light: {
          root: {
            background: 'var(--layout-link-text-color)',
            color: '{surface.0}',
            // TODO doesn't exist in 20 borderColor: 'var(--layout-link-text-color)',
            // TODO doesn't exist in 20 hoverBackground: 'var(--layout-link-text-color)',
            // TODO doesn't exist in 20 hoverColor: '{surface.0}',
            // TODO doesn't exist in 20 activeBackground: 'var(--layout-link-text-color)',
            // TODO doesn't exist in 20 activeColor: '{surface.0}',
          },
        },
        dark: {
          root: {
            background: 'var(--layout-link-text-color)',
            color: '{surface.0}',
            // TODO doesn't exist in 20 borderColor: 'var(--layout-link-text-color)',
            // TODO doesn't exist in 20 hoverBackground: 'var(--layout-link-text-color)',
            // TODO doesn't exist in 20 hoverColor: '{surface.0}',
            // TODO doesn't exist in 20 activeBackground: 'var(--layout-link-text-color)',
            // TODO doesn't exist in 20 activeColor: '{surface.0}',
          },
        },
      },
    },
    button: {
      colorScheme: {
        light: {
          root: {
            primary: {
              background: '{primary.500}',
              hoverBackground: '{primary.600}',
              activeBackground: '{primary.700}',
              borderColor: '{primary.500}',
              hoverBorderColor: '{primary.600}',
              activeBorderColor: '{primary.700}',
              color: 'var(--primary-contrast)',
              hoverColor: 'var(--primary-contrast)',
              activeColor: 'var(--primary-contrast)',
              focusRing: {
                color: 'transparent',
                shadow: '0 0 0 0.2rem {primary.200}',
              },
            },
            secondary: {
              background: 'var(--secondary-500)',
              hoverBackground: 'var(--secondary-600)',
              activeBackground: 'var(--secondary-700)',
              borderColor: 'var(--secondary-500)',
              hoverBorderColor: 'var(--secondary-600)',
              activeBorderColor: 'var(--secondary-700)',
              color: 'var(--secondary-contrast)',
              hoverColor: 'var(--secondary-contrast)',
              activeColor: 'var(--secondary-contrast)',
              focusRing: {
                color: 'transparent',
                shadow: '0 0 0 0.2rem var(--secondary-200)',
              },
            },
            info: {
              background: 'var(--info-500)',
              hoverBackground: 'var(--info-600)',
              activeBackground: 'var(--info-700)',
              borderColor: 'var(--layout-border-color)',
              hoverBorderColor: 'var(--info-600)',
              activeBorderColor: 'var(--info-700)',
              color: 'var(--info-contrast)',
              hoverColor: 'var(--info-contrast)',
              activeColor: 'var(--info-contrast)',
              focusRing: {
                color: 'transparent',
                shadow: '0 0 0 0.2rem var(--info-200)',
              },
            },
            success: {
              background: '{success.500}',
              hoverBackground: '{success.600}',
              activeBackground: '{success.700}',
              borderColor: '{success.500}',
              hoverBorderColor: '{success.600}',
              activeBorderColor: '{success.700}',
              color: '{success.contrastColor}',
              hoverColor: '{success.contrastColor}',
              activeColor: '{success.contrastColor}',
              focusRing: {
                color: 'transparent',
                shadow: '0 0 0 0.2rem {success.200}',
              },
            },
            warn: {
              background: '{warn.500}',
              hoverBackground: '{warn.600}',
              activeBackground: '{warn.700}',
              borderColor: '{warn.500}',
              hoverBorderColor: '{warn.600}',
              activeBorderColor: '{warn.700}',
              color: '{warn.contrastColor}',
              hoverColor: '{warn.contrastColor}',
              activeColor: '{warn.contrastColor}',
              focusRing: {
                color: 'transparent',
                shadow: '0 0 0 0.2rem {warn.200}',
              },
            },
            help: {
              background: '{help.500}',
              hoverBackground: '{help.600}',
              activeBackground: '{help.700}',
              borderColor: '{help.500}',
              hoverBorderColor: '{help.600}',
              activeBorderColor: '{help.700}',
              color: '{help.contrastColor}',
              hoverColor: '{help.contrastColor}',
              activeColor: '{help.contrastColor}',
              focusRing: {
                color: 'transparent',
                shadow: '0 0 0 0.2rem {help.200}',
              },
            },
            danger: {
              background: '{danger.500}',
              hoverBackground: '{danger.600}',
              activeBackground: '{danger.700}',
              borderColor: '{danger.500}',
              hoverBorderColor: '{danger.600}',
              activeBorderColor: '{danger.700}',
              color: '{danger.contrastColor}',
              hoverColor: '#ffffff',
              activeColor: '#ffffff',
              focusRing: {
                color: 'transparent',
                shadow: '0 0 0 0.2rem {danger.200}',
              },
            },
          },
          outlined: {
            secondary: {
              hoverBackground: 'var(--secondary-50)`',
              activeBackground: 'var(--secondary-100)',
              borderColor: 'var(--layout-border-color)',
              color: 'var(--secondary-500)',
            },
            success: {
              hoverBackground: '{success.50}',
              activeBackground: '{success.100}',
              borderColor: '{success.200}',
              color: '{success.500}',
            },
            info: {
              hoverBackground: 'var(--info--50)',
              activeBackground: 'var(--info-100)',
              borderColor: 'var(--layout-border-color)',
              color: 'var(--info-500)',
            },
            warn: {
              hoverBackground: '{warn.50}',
              activeBackground: '{warn.100}',
              borderColor: '{warn.200}',
              color: '{warn.500}',
            },
            help: {
              hoverBackground: '{help.50}',
              activeBackground: '{help.100}',
              borderColor: '{help.200}',
              color: '{help.500}',
            },
            danger: {
              hoverBackground: '{danger.50}',
              activeBackground: '{danger.100}',
              borderColor: '{danger.200}',
              color: '{danger.500}',
            },
            contrast: {
              borderColor: 'var(--layout-border-color)',
            },
          },
          text: {
            secondary: {
              hoverBackground: 'var(--secondary-100)',
              activeBackground: 'var(--secondary-200)',
              color: 'var(--secondary-600)',
            },
            success: {
              hoverBackground: '{success.50}',
              activeBackground: '{success.100}',
              color: '{success.500}',
            },
            info: {
              hoverBackground: 'var(--info-50)',
              activeBackground: 'var(--info-100)',
              color: 'var(--info-500)',
            },
            warn: {
              hoverBackground: '{warn.50}',
              activeBackground: '{warn.100}',
              color: '{warn.500}',
            },
            help: {
              hoverBackground: '{help.50}',
              activeBackground: '{help.100}',
              color: '{help.500}',
            },
            danger: {
              hoverBackground: '{danger.50}',
              activeBackground: '{danger.100}',
              color: '{danger.500}',
            },
          },
          link: {
            color: 'var(--layout-link-text-color)',
            hoverColor: 'var(--layout-link-text-color)',
            activeColor: 'var(--layout-link-text-color)',
          },
        },
        dark: {
          root: {
            primary: {
              background: '{primary.500}',
              hoverBackground: '{primary.600}',
              activeBackground: '{primary.700}',
              borderColor: '{primary.500}',
              hoverBorderColor: '{primary.600}',
              activeBorderColor: '{primary.700}',
              color: 'var(--primary-contrast)',
              hoverColor: 'var(--primary-contrast)',
              activeColor: 'var(--primary-contrast)',
              focusRing: {
                color: 'transparent',
                shadow: '0 0 0 0.2rem {primary.200}',
              },
            },
            secondary: {
              background: 'var(--secondary-500)',
              hoverBackground: 'var(--secondary-600)',
              activeBackground: 'var(--secondary-700)',
              borderColor: 'var(--secondary-500)',
              hoverBorderColor: 'var(--secondary-600)',
              activeBorderColor: 'var(--secondary-700)',
              color: 'var(--secondary-contrast)',
              hoverColor: 'var(--secondary-contrast)',
              activeColor: 'var(--secondary-contrast)',
              focusRing: {
                color: 'transparent',
                shadow: '0 0 0 0.2rem var(--secondary-200)',
              },
            },
            info: {
              background: 'var(--info-500)',
              hoverBackground: 'var(--info-600)',
              activeBackground: 'var(--info-700)',
              borderColor: 'var(--layout-border-color)',
              hoverBorderColor: 'var(--info-600)',
              activeBorderColor: 'var(--info-700)',
              color: 'var(--info-contrast)',
              hoverColor: 'var(--info-contrast)',
              activeColor: 'var(--info-contrast)',
              focusRing: {
                color: 'transparent',
                shadow: '0 0 0 0.2rem var(--info-200)',
              },
            },
            success: {
              background: '{success.500}',
              hoverBackground: '{success.600}',
              activeBackground: '{success.700}',
              borderColor: '{success.500}',
              hoverBorderColor: '{success.600}',
              activeBorderColor: '{success.700}',
              color: '{success.contrastColor}',
              hoverColor: '{success.contrastColor}',
              activeColor: '{success.contrastColor}',
              focusRing: {
                color: 'transparent',
                shadow: '0 0 0 0.2rem {success.200}',
              },
            },
            warn: {
              background: '{warn.500}',
              hoverBackground: '{warn.600}',
              activeBackground: '{warn.700}',
              borderColor: '{warn.500}',
              hoverBorderColor: '{warn.600}',
              activeBorderColor: '{warn.700}',
              color: '{warn.contrastColor}',
              hoverColor: '{warn.contrastColor}',
              activeColor: '{warn.contrastColor}',
              focusRing: {
                color: 'transparent',
                shadow: '0 0 0 0.2rem {warn.200}',
              },
            },
            help: {
              background: '{help.500}',
              hoverBackground: '{help.600}',
              activeBackground: '{help.700}',
              borderColor: '{help.500}',
              hoverBorderColor: '{help.600}',
              activeBorderColor: '{help.700}',
              color: '{help.contrastColor}',
              hoverColor: '{help.contrastColor}',
              activeColor: '{help.contrastColor}',
              focusRing: {
                color: 'transparent',
                shadow: '0 0 0 0.2rem {help.200}',
              },
            },
            danger: {
              background: '{danger.500}',
              hoverBackground: '{danger.600}',
              activeBackground: '{danger.700}',
              borderColor: '{danger.500}',
              hoverBorderColor: '{danger.600}',
              activeBorderColor: '{danger.700}',
              color: '{danger.contrastColor}',
              hoverColor: '#ffffff',
              activeColor: '#ffffff',
              focusRing: {
                color: 'transparent',
                shadow: '0 0 0 0.2rem {danger.200}',
              },
            },
          },
          outlined: {
            secondary: {
              hoverBackground: 'var(--secondary-50)',
              activeBackground: 'var(--secondary-100)',
              borderColor: 'var(--layout-border-color)',
              color: 'var(--secondary-500)',
            },
            success: {
              hoverBackground: '{success.50}',
              activeBackground: '{success.100}',
              borderColor: '{success.200}',
              color: '{success.500}',
            },
            info: {
              hoverBackground: 'var(--info-50)',
              activeBackground: 'var(--info-100)',
              borderColor: 'var(--layout-border-color)',
              color: 'var(--info-500)',
            },
            warn: {
              hoverBackground: '{warn.50}',
              activeBackground: '{warn.100}',
              borderColor: '{warn.200}',
              color: '{warn.500}',
            },
            help: {
              hoverBackground: '{help.50}',
              activeBackground: '{help.100}',
              borderColor: '{help.200}',
              color: '{help.500}',
            },
            danger: {
              hoverBackground: '{danger.50}',
              activeBackground: '{danger.100}',
              borderColor: '{danger.200}',
              color: '{danger.500}',
            },
            contrast: {
              borderColor: '{surface.600}',
            },
          },
          text: {
            secondary: {
              hoverBackground: 'var(--secondary-100)',
              activeBackground: 'var(--secondary-200)',
              color: 'var(--secondary-600)',
            },
            success: {
              hoverBackground: '{success.50}',
              activeBackground: '{success.100}',
              color: '{success.500}',
            },
            info: {
              hoverBackground: 'var(--info-50)',
              activeBackground: 'var(--info-100)',
              color: 'var(--info-500)',
            },
            warn: {
              hoverBackground: '{warn.50}',
              activeBackground: '{warn.100}',
              color: '{warn.500}',
            },
            help: {
              hoverBackground: '{help.50}',
              activeBackground: '{help.100}',
              color: '{help.500}',
            },
            danger: {
              hoverBackground: '{danger.50}',
              activeBackground: '{danger.100}',
              color: '{danger.500}',
            },
          },
          link: {
            color: 'var(--layout-link-text-color)',
            hoverColor: 'var(--layout-link-text-color)',
            activeColor: 'var(--layout-link-text-color)',
          },
        },
      },
    },
  },
});

export default customPreset;
